import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import EconomicChart from '../EconomicChart';

class IncomeStatement extends Component {
	render() {
		const {
			incomeStatement: {
				revenues,
				directMaterialCosts,
				outsourcedProductionCosts,
				sellingCommissions,
				contributionMargin,
				productionOverheads,
				marketingExpenses,
				sellingExpenses,
				generalAndAdministrativeExpenses,
				operatingIncome,
				interestExpensesLongTerm,
				interesetExpensesOnBankOverdraft,
				preTaxIncomeWithShortTerm,
				taxes,
				netIncome
			}
		} = this.props.game;

		const data = [
			{ label: 'Revenues', values: revenues },
			{ label: 'Direct Material Costs', values: directMaterialCosts },
			{
				label: 'Total Outsourced production costs',
				values: outsourcedProductionCosts
			},
			{ label: 'Selling commissions', values: sellingCommissions },
			{ label: 'Contribution Margin', values: contributionMargin },
			{ label: 'Production Overheads', values: productionOverheads },
			{ label: 'Marketing expenses', values: marketingExpenses },
			{ label: 'Selling expenses', values: sellingExpenses },
			{
				label: 'General and administrative expenses',
				values: generalAndAdministrativeExpenses
			},
			{ label: 'Operating Income (EBIT)', values: operatingIncome },
			{
				label: 'Interest expenses on long-term debts',
				values: interestExpensesLongTerm
			},
			{
				label: 'Interest expenses on short-term debts (line of credit)',
				values: interesetExpensesOnBankOverdraft
			},
			{ label: 'Pre-tax Income', values: preTaxIncomeWithShortTerm },
			{ label: 'Taxes', values: taxes },
			{ label: 'Net Income', values: netIncome }
		];

		return (
			<div className="income-statement">
				<EconomicChart data={data} />
			</div>
		);
	}
}

IncomeStatement.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		incomeStatement: PropTypes.shape({
			revenues: MultiYearScalarType,
			directMaterialCosts: MultiYearScalarType,
			outsourcedProductionCosts: MultiYearScalarType,
			sellingCommissions: MultiYearScalarType,
			contributionMargin: MultiYearScalarType,
			productionOverheads: MultiYearScalarType,
			marketingExpenses: MultiYearScalarType,
			sellingExpenses: MultiYearScalarType,
			generalAndAdministrativeExpenses: MultiYearScalarType,
			operatingIncome: MultiYearScalarType,
			interestExpensesLongTerm: MultiYearScalarType,
			interesetExpensesOnBankOverdraft: MultiYearScalarType,
			preTaxIncomeWithShortTerm: MultiYearScalarType,
			taxes: MultiYearScalarType,
			netIncome: MultiYearScalarType
		})
	})
};

export default IncomeStatement;
